<template>
	<div>
		<div :class="'egranty-table' + (compact ? ' compact-table' : '')">
			<v-toolbar class="egrantyTableToolbar" flat>
				<v-toolbar-title>{{ tableName }}</v-toolbar-title>
				<v-spacer></v-spacer>

				<v-btn color="primary" @click="exportData" dark>
					<v-icon>save_alt</v-icon>
					Eksportuj
				</v-btn>

				<hideable-columns-menu :columns="headers"
					@column-toggled="columnToggled"
					:column-visibilities="columnVisibility"
					v-if="hideableColumns"/>
			</v-toolbar>

			<v-btn v-if="toolbarActionName !== '' && toolbarActionVisible"
				color="primary" dark
				@click="$emit('toolbarAction')">
				{{ toolbarActionName }}
			</v-btn>

			<v-data-table
				:key="tableKey"
				:headers="computedHeaders"
				:items="computedItems"
				:hide-actions="hidePagination"
				:pagination.sync="sortOptions"
				item-key="name"
				class="elevation-1">

				<template slot="headerCell" slot-scope="{ header }">
					<div :class="'column-header ' + getHeaderClass(header)">
						<template v-if="header.filterable">
							<v-text-field
								browser-autocomplete="off"
								v-model="searchModel[header.value]"
								append-icon="search"
								hide-details box clearable
								class="pa-0 mb-2 egranty-table-header-search"
								@click="eatEvent"
								v-if="header.type === 'TEXT' || header.type === 'NUMBER' || header.type === 'CURRENCY'"
								aria-label="label for text"
							></v-text-field>
							<egranty-three-state-switch
								v-model="searchModel[header.value]"
								@click="eatEvent"
								v-if="header.type === 'BOOLEAN'"
								aria-label="label for switch"
							></egranty-three-state-switch>
							<div class="select-committee-decision">
								<v-select v-if="header.type === 'COMMITTEE_DECISION'" :items="committeeDecisions"
									v-model="searchModel[header.value]"
									aria-label="committee decision">
								</v-select>
							</div>
						</template>
						<v-tooltip bottom v-if="header.tooltip">
							<template v-slot:activator="{ on }">
								<span v-text="header.text" v-on="on" class="mr-3"/>
							</template>
							<span>{{header.tooltip}}</span>
						</v-tooltip>
						<span v-else v-text="header.text" class="mr-3"/>
					</div>
				</template>

				<template slot="items" slot-scope="{ item, index }">
					<tr>
						<template v-for="(header, headerIndex) in computedHeaders">
							<template v-if="header.editable">
								<td v-if="header.type === 'CURRENCY' && disableAllFields"
									v-bind:key="headerIndex +10000" :class="getCellClass(header)">
									<template class="text-xs-right">
										{{ formatMoney(item[header.value]) }}
									</template>
								</td>
								<td v-else :class="getCellClass(header)" :key="'cell-' + headerIndex">
									<v-text-field v-model="item[header.value]"
										browser-autocomplete="off"
										aria-label="laber for text"
										@change="emitUpdateEvent(item)"
										v-if="header.type === 'TEXT'" :disabled="disableAllFields">
									</v-text-field>
									<v-text-field v-model="item[header.value]"
										browser-autocomplete="off"
										@change="emitUpdateEvent(item)"
										type="number" :disabled="disableAllFields"
										v-if="(header.type === 'NUMBER') && isNotUndefinedModuleInput(item, header)"
										aria-label="label for text">
									</v-text-field>
									<egranty-number-input-field
										v-on:bl="emitUpdateEvent(item)"
										v-model="item[header.value]"
										:double-mechanism="false"
										:disabled="disableAllFields"
										v-if="header.type === 'CURRENCY' && !disableAllFields && isNotUndefinedModuleInput(item, header)"
									>
									</egranty-number-input-field>
									<egranty-three-state-switch v-model="item[header.value]"
										@change="emitUpdateEvent(item)"
										v-if="header.type === 'BOOLEAN'" :disable-all-fields="disableAllFields">
									</egranty-three-state-switch>
									<v-select v-if="header.type === 'COMMITTEE_DECISION'" :disabled="disableAllFields"
										v-model="decisionLinkers.find(d => d.id === item.id).value"
										@change="validateDecisionAndEmitUpdateEvent(item)"
										:items="committeeDecisions"
										aria-label="committee decision">
									</v-select>
								</td>
							</template>

							<td :class="getCellClass(header)" :key="'cell-' + headerIndex"
								v-else-if="!header.isActionsHeader && !header.editable">
								<template v-if="header.type === 'COMMITTEE_DECISION'">
									<v-icon v-if="item[header.value] === true">done</v-icon>
									<v-icon v-else-if="item[header.value] === false">clear</v-icon>
									<v-icon v-else-if="item[header.value] === null">help_outline</v-icon>
								</template>
								<template v-else-if="header.type === 'NUMBER' && header.value === 'index'">{{index+1}}
								</template>
								<template v-else-if="header.type === 'BOOLEAN'">
									<template v-if="item[header.value] === true">
										<v-icon>done</v-icon>
									</template>
									<template v-else-if="item[header.value] === false">
										<v-icon>clear</v-icon>
									</template>
									<template v-else>
										<v-icon v-if="agencyEvaluation(header.value)">{{ item.agencyEvaluationAssigned ?
											'help_outline' : '' }}
										</v-icon>
										<v-icon v-else-if="expertEvaluation(header.value)">{{
											expertEvaluatorPresent(item, header.value) ? 'help_outline' : '' }}
										</v-icon>
										<v-icon v-else>help_outline</v-icon>
									</template>
								</template>
								<template v-else-if="header.type === 'CURRENCY'">
									{{ formatMoney(item[header.value]) }}
								</template>
								<template v-else-if="substantiveEvaluation(header.value)">
									<template v-if="substantiveEvaluatorPresent(item, header.value)">
										<template v-if="item[header.value] || item[header.value] === 0">{{
											item[header.value].toString().replace(/\./g, ",")
										}}
										</template>
										<template v-else>
											<v-icon>help_outline</v-icon>
										</template>
									</template>
									<template v-else>
										{{ item[header.value] ? item[header.value].toString().replace(/\./g, ",") :
											item[header.value] }}
									</template>
								</template>
								<template v-else>
									{{ item[header.value] && !isNaN(item[header.value]) ?
										item[header.value].toString().replace(/\./g, ",") :
										item[header.value] }}
								</template>
							</td>
						</template>

						<td v-if="hasActions && rowActionsVisible" class="text-xs-right">
							<template v-for="(action, actionIndex) in rowActions">
								<egranty-icon-button
									small
									:key="'action-' + actionIndex"
									:icon="action.icon"
									:label="action.label"
									@click="$emit(action.name, item)"
								></egranty-icon-button>
							</template>
						</td>
					</tr>

					<tr v-if="(index + 1) % 10 === 0 && computedItems.length - 1 > index" class="header-duplicate-row">
						<template v-for="(header, headerIndex) in computedHeaders">
							<td class="text-xs-left" :key="'header-duplicate-cell-' + index + '-' + headerIndex">
								{{ header.text }}
							</td>
						</template>
					</tr>
					<tr v-if="hasFooterWithSums && index === computedItems.length - 1" class="footer-row">
						<template v-for="(header, headerIndex) in computedHeaders">
							<td :class="getCellClass(header) + ' footer-cell'" :key="'footer-cell-' + headerIndex">
								{{ header.summable ? formatMoney(header.computedSum) : "" }}
							</td>
						</template>
					</tr>
				</template>
			</v-data-table>
		</div>
		<v-card>
			<v-card-title>
				<h2 class="ml-2">Podsumowanie ofert</h2>
			</v-card-title>
			<v-card-text>
				<v-container fluid>
					<v-layout>
						<v-flex xs12 sm4>
							Kwoty wnioskowane: {{ formatMoney(requestedSum) }}
						</v-flex>
						<v-flex xs12 sm4>
							Kwoty rekomendowane: {{ formatMoney(recommendedSum) }}
						</v-flex>
						<v-flex xs12 sm4>
							Redukcje: {{ formatMoney(reductionSum) }}
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
	import {Files} from "@/utils/Files";
	import {Dates} from "@/utils/Dates";
	import {Numbers} from "@/utils/Numbers";
	import HideableColumnsMenu from "../../../../genericComponents/egrantyTable/HideableColumnsMenu";
	import EgrantyThreeStateSwitch from "../../../../genericComponents/EgrantyThreeStateSwitch";
	import {Api} from "@/api";
	import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";

	export default {

		name: "EvaluationSummaryTable",
		components: {
			EgrantyNumberInputField,
			EgrantyThreeStateSwitch, HideableColumnsMenu,
		},

		mixins: [Files, Dates, Numbers],

		data() {
			return {
				tableKey: false,
				columnVisibility: null,
				searchModel: {},
				committeeDecisions: ["-", "TAK", "NIE", "REZERWA"],
				decisionLinkers: [],
				sortOptions: {}
			};
		},
    
		destroyed() {
			this.$store.commit("evaluationTableFilters", {});
			this.$store.commit("evaluationTableSortOptions", {});
		},

		watch: {
			headers: function (newVal) {
				if (this.columnVisibility === null) {
					this.columnVisibility = newVal
						.reduce((obj, h) => {
							obj[h.value] = true;
							return obj;
						}, {});
				}

				if (Object.keys(this.$store.state.evaluationTableSortOptions).length > 0) {
					this.sortOptions = this.$store.state.evaluationTableSortOptions;
				}

				if (Object.keys(this.$store.state.evaluationTableFilters).length > 0) {
					this.searchModel = this.$store.state.evaluationTableFilters;
				} else {
					this.searchModel = newVal
						.reduce((obj, header) => {
							if (header.type === "BOOLEAN") {
								obj[header.value] = "ALL";
							} else if (header.type === "COMMITTEE_DECISION") {
								obj[header.value] = "-";
							} else {
								obj[header.value] = "";
							}
							return obj;
						}, {});
				}
				/*
				  table rerender, used to fix bug with values shifting between rows
          when any changes are applied to the table with filters turned on
				 */
				this.tableKey = !this.tableKey;
			},

			items: function () {
				this.items.forEach(offer => {
					let decision = {
						id: offer.id,
						value: offer.committeeDecision === "RESERVE" ? "REZERWA" :
							offer.committeeDecision === "RECOMMENDED" ? "TAK" :
							offer.committeeDecision === "NOT_RECOMMENDED" ? "NIE" : "-",
					};
					this.decisionLinkers.push(decision);
				});
			},
		},

		computed: {
			columnFilters () {
				return this.headers.map(
					header => {
						let ctx = this;
						switch (header.type) {
							case "NUMBER":
								return getNumberFilter(ctx, header.value);
							case "CURRENCY":
								return getNumberFilter(ctx, header.value);
							case "TEXT":
								return getTextFilter(ctx, header.value);
							case "BOOLEAN":
								return getBooleanFilter(ctx, header.value);
							case "COMMITTEE_DECISION":
								return getCommitteeDecisionFilter(ctx, header.value);
							default:
								return getTextFilter(ctx, header.value);
						}
					},
				);
			},

			computedHeaders () {
				let computedHeaders = [...this.headers];

				if (this.hasActions) {
					computedHeaders.push({
						text: "Akcje",
						width: "10%",
						value: "egranty-table-actions",
						align: "center",
						sortable: false,
						isActionsHeader: true,
					});
				}

				if (this.hideableColumns) {
					computedHeaders = computedHeaders.filter(h => this.columnVisibility[h.value]);
				}

				computedHeaders
					.filter(h => !h.type && !h.isActionsHeader)
					.forEach(h => this.$set(h, "type", "TEXT"));

				return computedHeaders;
			},

			computedItems () {
				let result = [...this.items];
				result = JSON.parse(JSON.stringify(result));	// deepcopy
				for (let i = 0; i < result.length; ++i) {
					this.$set(result[i], "egrantyTableIndex", i);
				}
				this.computedHeaders.forEach(
					header => {
						result.forEach(item => {
							if (header.postProcessor) {
								this.$set(item, header.value, header.postProcessor(item));
							}
						});
					},
				);
				let allFilters = [...this.rowFilters, ...this.columnFilters];
				allFilters.forEach(f => result = result.filter(f));
				this.computedHeaders.forEach(
					header => {
						this.$set(header, "computedSum", 0);
						result.forEach(item => {
							if (header.summable) {
								header.computedSum = header.computedSum + (parseFloat(item[header.value]) || 0);
							}
						});
					},
				);
				return result;
			},

			hasActions () {
				return this.rowActions.length > 0;
			},

			hasFooterWithSums () {
				return this.headers.some(h => h.summable);
			},

			requestedSum () {
				let sum = 0;
				this.computedItems.forEach(i => {
					sum += i.requestedDotations.reduce((prev, cur) => prev + cur);
				});
				return sum;
			},

			recommendedSum () {
				let sum = 0;
				this.computedItems.forEach(i => {
					sum += i.appliedDotations.reduce((prev, cur) => prev + cur);
				});
				return sum;
			},

			reductionSum () {
				return this.requestedSum - this.recommendedSum;
			},
		},

		methods: {
			isNotUndefinedModuleInput (item, header) {
				const endsWithNumber = new RegExp("(appliedDotations)(\\d+)");
				if (endsWithNumber.test(header.value)) {
					const result = endsWithNumber.exec(header.value);
					return result[2] - 1 < item.moduleCount;
				}
				return true;
			},

			eatEvent (e) {
				e.stopPropagation();
			},

			getVisibilityFunction (action) {
				return typeof action.isVisible === "function" ? action.isVisible : () => true;
			},

			async validateDecisionAndEmitUpdateEvent (item) {
        let decisionLinker = this.decisionLinkers.find(d => d.id === item.id);
				if (["TAK", "REZERWA"].includes(decisionLinker.value)) {
					if (!this.validateThatOfferEvaluationIsOverThreshold(item)) {
						decisionLinker.value = await "-";
						this.$messagesBus.$emit("error", "Oferta nie może być rekomendowana / rezerwowa, bo nie przekroczyła progu rekomendacji!");
						return;
					}
				}
				let valueToSet = decisionLinker.value === "REZERWA" ? "RESERVE" :
					decisionLinker.value === "TAK" ? "RECOMMENDED" :
					decisionLinker.value === "NIE" ? "NOT_RECOMMENDED" : null;
				this.$set(item, "committeeDecision", valueToSet);
				this.emitUpdateEvent(item);
			},
      
			emitUpdateEvent(item) {
				this.$store.commit("evaluationTableFilters", this.searchModel);
				this.$store.commit("evaluationTableSortOptions", this.sortOptions);
				this.$emit("item-updated", item);
			},

			substantiveEvaluation (headerValue) {
				return headerValue.startsWith('substantiveEvaluationsPointSums');
			},

			agencyEvaluation (headerValue) {
				return headerValue.startsWith('agencyEvaluation');
			},

			expertEvaluation (headerValue) {
				return headerValue.startsWith('expertEvaluations');
			},

			substantiveEvaluatorPresent (item, headerValue) {
				let evaluationIndex = headerValue.substring(31);
				let found = this.computedItems.find(computed => computed.id === item.id);
				return found['committeeNames' + evaluationIndex];
			},

			expertEvaluatorPresent (item, headerValue) {
				let evaluationIndex = headerValue.substring(17);
				return evaluationIndex <= item.expertEvaluationCount;
			},

			validateThatOfferEvaluationIsOverThreshold (item) {
				let offerPoints = this.sumAllPoints(item);
				if (this.ratingSettings.booleanEvaluation) {
					return true;
				} else if (!this.ratingSettings.recommendationThresholdExpressedInPercentage) {
					return (offerPoints >= this.ratingSettings.recommendationThreshold);
				} else {
					return true;
				}
			},

			sumAllPoints (offer) {
				let points = 0;
				points += Math.round((parseFloat(offer.collaborationEvaluation) || 0) * 2);
				points += (parseFloat(offer.relevancy) || 0) * this.ratingSettings.firstCommitteeCriteriaMultiplier;
				points += (parseFloat(offer.efficiency) || 0) * this.ratingSettings.secondCommitteeCriteriaMultiplier;
				points += (parseFloat(offer.averageSubstantiveEvaluationsPoints) || 0);
				return points;
			},

			getAverage (values) {
				if (!values) return null;
				let count = values.length;
				if (count === 0) return 0;
				let sum = values.reduce((a, b) => a + b, 0) || 0;
				return sum / count;
			},

			columnToggled (columnKey, newVisibility) {
				this.columnVisibility[columnKey] = newVisibility;
			},

			notBooleanColumn (key) {
				return !key.includes('formalEvaluations') &&
					!key.includes('agencyEvaluation') &&
					!key.includes('substantiveEvaluationsRecommendings');
			},

			getHeaderClass (header) {
				let cssClass = "";
				switch (header.type) {
					case "TEXT":
						cssClass = "text-column-header";
						break;
					case "NUMBER":
					case "CURRENCY":
						cssClass = "number-column-header";
						break;
					case "BOOLEAN":
						cssClass = "boolean-column-header";
						break;
					case "COMMITTEE_DECISION":
						cssClass = "committee-column-header";
						break;
				}
				if (header.headerClass) {
					cssClass += " " + header.headerClass;
				}
				return cssClass;
			},

			getCellClass (header) {
				let cssClass = "";
				switch (header.type) {
					case "TEXT":
						cssClass = "text-xs-left";
						break;
					case "NUMBER":
					case "CURRENCY":
						cssClass = "text-xs-right";
						break;
					case "COMMITTEE_DECISION":
					case "BOOLEAN":
						cssClass = "text-xs-center";
						break;
				}
				if (header.cellClass) {
					cssClass += " " + header.cellClass;
				}
				return cssClass;
			},

			exportData () {
				let data = {
					headers: this.computedHeaders
						.filter(h => !h.isActionsHeader)
						.map(h => {
							return {
								caption: h.text,
								key: h.value,
								type: h.type,
							};
						}, {}),
					rows: this.computedItems,
				};
				Api.post(this, "/data-export/xls", data,
					success => {
						let filename = "egranty_export_" + this.getFilenameTimestamp() + ".xlsx";
						this.$messagesBus.$emit("success", "Eksport danych z tabeli wykonano do pliku " + filename,
							success);
						this.downloadBlobResponse(success, filename);
					}, error => {
						this.$messagesBus.$emit("error", "Eksport nieudany", error);
					},
					{responseType: "blob"});
			},
		},

		props: {
			/**
			 * Kopiowane, filtrowane i przekazywane do v-data-table:items.
			 */
			items: {type: Array, required: true, default: () => []},

			/**
			 * Kopiowane i przekazywane do v-data-table:headers. Jeśli tabela zawiera akcje,
			 * dodawany jest nagłówek z akcjami.
			 *
			 * Dodatkowe pola:
			 * - postProcessor: (Function(item)) - funkcja do zmiany wartości danego pola dla item
			 * - filterable: (Boolean) - czy kolumna może być filtrowana
			 * - editable: (Boolean) - czy pola można edytować
			 * - summable: (Boolean) - czy kolumna będzie zawierała sumę z komórek w ostatnim wierszu tabeli
			 * - type: (String: TEXT, NUMBER, CURRENCY, BOOLEAN) - wpływa na metodę filtrowania i sortowania
			 * - cellClass: (String) - klasa css dodawana do każdej komórki
			 * - headerClass: (String) - klasa css dodawana do każdego nagłówka
			 */
			headers: {type: Array, required: true, default: () => []},
			rowActions: {type: Array, default: () => []},
			rowActionsVisible: {type: Boolean, default: true},
			toolbarActionName: {type: String, default: ""},
			toolbarActionVisible: {type: Boolean, default: true},
			hidePagination: {type: Boolean, default: false},
			tableName: {type: String, default: ""},
			rowFilters: {type: Array, default: () => []},
			hideableColumns: {type: Boolean, default: false},
			exportEnabled: {type: Boolean, default: false},
			compact: {type: Boolean, default: false},
			disableAllFields: {type: Boolean, default: false},
			ratingSettings: {type: Object}
		},
	};

	function getTextFilter (ctx, key) {
		return getFilter(ctx, key, (v, q) => {
			if (v && q) {
				return v.toUpperCase().indexOf(q.toUpperCase()) >= 0;
			} else {
				return null;
			}
		});
	}

	function getNumberFilter (ctx, key) {
		return getFilter(ctx, key, (v, q) => v.toString().startsWith(q));
	}

	function getBooleanFilter (ctx, key) {
		if (ctx.agencyEvaluation(key)) {
			return getAgencyEvaluationFilter(ctx, key);
		}
		if (ctx.expertEvaluation(key)) {
			return getExpertEvaluationFilter(ctx, key);
		}
		return getFilter(ctx, key, (v, q) => {
			return (v === true ? "PASSED" :
				v === false ? "NOT_PASSED" :
				"UNKNOWN") === q;
		});
	}

	function getAgencyEvaluationFilter (ctx, key) {
		return function (item) {
			if (ctx.searchModel[key] === "PASSED") {
				return item[key] === true;
			} else if (ctx.searchModel[key] === "NOT_PASSED") {
				return item[key] === false;
			} else if (ctx.searchModel[key] === "UNKNOWN") {
				return item.agencyEvaluationAssigned && item[key] === null;
			} else return true;
		};
	}

	function getExpertEvaluationFilter (ctx, key) {
		return function (item) {
			if (ctx.searchModel[key] === "PASSED") {
				return item[key] === true;
			} else if (ctx.searchModel[key] === "NOT_PASSED") {
				return item[key] === false;
			} else if (ctx.searchModel[key] === "UNKNOWN") {
				return ctx.expertEvaluatorPresent(item, key) && item[key] === null;
			} else return true;
		};
	}

	function getCommitteeDecisionFilter (ctx, key) {
		return getFilter(ctx, key, (v, q) => (q === "REZERWA" ? "RESERVE" :
			q === "TAK" ? "RECOMMENDED" :
			q === "NIE" ? "NOT_RECOMMENDED" : null) === v);
	}

	function getFilter (ctx, key, testFunction) {
		return function (item) {
			if (ctx.searchModel[key] === "-" || ctx.searchModel[key] === "" || ctx.searchModel[key] === null || ctx.searchModel[key] === "ALL") {
				return true;
			}
			if (ctx.notBooleanColumn(key) &&
				(item[key] === undefined || item[key] === null || item[key] === "") &&
				(ctx.searchModel[key] !== undefined && ctx.searchModel[key] !== null && ctx.searchModel[key] !== "")) {
				return false;
			}
			return testFunction(item[key], ctx.searchModel[key]);
		};
	}
</script>

<style>
	.v-text-field--box > .v-input__control > .v-input__slot {
		height: 24px;
		line-height: 24px;
		min-height: 24px;
	}

	.v-text-field--box > .v-input__control > .v-input__slot input {
		padding: 0px;
		margin: 0px;
		font-size: 0.7em;
	}

	.v-text-field.v-text-field--enclosed .v-input__append-inner {
		margin-top: 0px;
	}

	.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
		padding: 0 5px;
	}

	.v-text-field .v-input__append-inner {
		padding-left: 0px;
	}

	.v-datatable thead th.column.sortable.active.desc .v-input .v-icon {
		-webkit-transform: none;
		transform: none;
	}

	.v-datatable thead th.column.sortable .boolean-column-header button i.v-icon {
		opacity: 1;
		color: inherit;
	}

	.committee-column-header select {
		display: block;
		margin-left: auto;
		height: 26px;
		width: 26px;
		margin-right: auto;
		margin-top: 0;
	}

	.boolean-column-header button {
		display: block;
		margin-left: auto;
		height: 26px;
		width: 26px;
		margin-right: auto;
		margin-top: 0;
	}

	tr.footer-row {
		background: lightgray;
		font-weight: bold;
	}

	tr.header-duplicate-row {
		background: #f2f2f2;
		font-weight: bold;
	}

	.compact-table .v-text-field.v-text-field--enclosed .v-input__append-inner {
		height: 18px;
		width: 18px;
		min-width: 18px;
	}

	.compact-table table.v-table tbody td {
		font-weight: 400;
		font-size: 14px;
		padding: 0 4px;
	}

	.compact-table table.v-table thead th {
		font-weight: 400;
		font-size: 10px;
		padding: 0 4px;
		vertical-align: top;
	}

	.compact-table table.v-table tbody td input {
		font-weight: 400;
		font-size: 10px;
	}

	.compact-table .column-header span {
		display: inline-block;
		white-space: normal;
	}

	.compact-table .text-column-header span {
		min-width: 130px;
	}

	.compact-table .number-column-header span {
		min-width: 70px;
	}

	.compact-table .boolean-column-header span {
		min-width: 70px;
	}

	.compact-table .column-header.header-index span {
		min-width: 40px;
	}

	.theme--dark .v-btn .v-btn__content .v-icon {
		color: #fff !important;
	}

	.select-committee-decision .v-text-field {
		padding: 0;
		margin: 0;
	}

	.select-committee-decision .v-select {
		top: -8px;
		background-color: rgba(0, 0, 0, 0.06);
	}

	.select-committee-decision .v-select:hover {
		background-color: rgba(0, 0, 0, 0.1);
	}

	.select-committee-decision .v-select .v-input__control {
		margin-bottom: -20px !important;
	}

	.select-committee-decision .v-text-field > .v-input__control > .v-input__slot:before {
		border: solid 1px rgba(0, 0, 0, 0.42);
	}

	.select-committee-decision .v-select__selection--comma {
		position: relative;
		top: 5px;
		left: 5px;
	}

	.cell-relevancy .v-input .v-input__control .v-input__slot input,
	.cell-efficiency .v-input .v-input__control .v-input__slot input,
	[class*="cell-appliedDotations"] .v-input .v-input__control .v-input__slot input{
		text-align: right;
		font-size: 14px;
	}

</style>
